import * as $ from 'jquery';

import { Ui } from 'src/integration/api/ui/Ui';

import { D2lConfig } from '../D2lConfig';
import { D2lContentItem } from '../D2lContentItem';
import { ID2lContentItemAnnotator } from '../ID2lContentItemAnnotator';

import { D2lAlternativeFormatsTransparentButton } from './templates/D2lAlternativeFormatsTransparentButton';

export class NewLearnerExperienceViewAnnotator implements ID2lContentItemAnnotator {
    /**
     * An annotator that's responsible for adding an "Alternative formats" button in the new Learner Experience view.
     *
     * @param config The ally configuration holding basic information
     * @param item array of D2L content items from the new learner experience page.
     * @returns boolean
     */
    public annotate(config: D2lConfig, item: D2lContentItem, ui: Ui): boolean {
        let hasDomUpdate = false;
        if (config.parsedToken.can_download_content) {
            const aafIcon = new D2lAlternativeFormatsTransparentButton();
            const $aafIcon = $(aafIcon.apply({
                'baseUrl': config.baseUrl,
                'contentRef': item.id,
                'i18n': ui.i18n
            }));
            item.$el.prepend($aafIcon);
            hasDomUpdate = true;
        }
        return hasDomUpdate;
    }
}
